import axios from "axios";

const BASE_URL = "https://backdanlu.eu-4.evennode.com";

// ✅ GET: Traer todos los estaciones
export const getEstaciones = async () => {
  const token = localStorage.getItem("token") || "";

  const url = `${BASE_URL}/estaciones`;

  try {
    const resp = await axios.get(url, {
      headers: { token },
    });
    return resp.data;
  } catch (error) {
    return {
      ok: false,
      error: error.response?.data || "Error al obtener estaciones",
    };
  }
};

// ✅ GET: Traer un estacion por ID
export const getEstacionById = async (id) => {
  const token = localStorage.getItem("token") || "";

  const url = `${BASE_URL}/estaciones/${id}`;

  try {
    const resp = await axios.get(url, {
      headers: { token },
    });
    return resp.data;
  } catch (error) {
    return {
      ok: false,
      error: error.response?.data || "Error al obtener estacion",
    };
  }
};

// ✅ POST: Crear nuevo estacion
export const postEstacion = async (estacionData) => {
  const token = localStorage.getItem("token") || "";

  const url = `${BASE_URL}/estaciones`;

  try {
    const resp = await axios.post(url, estacionData, {
      headers: {
        "Content-Type": "application/json",
        token,
      },
    });
    return resp.data;
  } catch (error) {
    return {
      ok: false,
      error: error.response?.data || "Error al crear estacion",
    };
  }
};

// ✅ PUT: Actualizar estacion
export const putEstacion = async (id, estacionData) => {
  const token = localStorage.getItem("token") || "";

  const url = `${BASE_URL}/estaciones/${id}`;

  try {
    const resp = await axios.put(url, estacionData, {
      headers: {
        "Content-Type": "application/json",
        token,
      },
    });
    return resp.data;
  } catch (error) {
    return {
      ok: false,
      error: error.response?.data || "Error al actualizar estacion",
    };
  }
};

// ✅ DELETE: Desactivar estacion
export const deleteEstacion = async (id) => {
  const token = localStorage.getItem("token") || "";

  const url = `${BASE_URL}/estaciones/${id}`;

  try {
    const resp = await axios.delete(url, {
      headers: { token },
    });
    return resp.data;
  } catch (error) {
    return {
      ok: false,
      error: error.response?.data || "Error al eliminar estacion",
    };
  }
};
